import TourGamesPicksView from './TourGamesPicksView';
export default TourGamesPicksView